import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export const chartHeight: number = 300;
export let getLocalStorage = JSON.parse(localStorage.getItem("token")!);
export let BEARER_TOKEN = getLocalStorage?.access_token;
export const setLocalStorageToken = (data: any) => {
  getLocalStorage = JSON.parse(data);
  setBearerToken();
  return getLocalStorage;
};
export const setBearerToken = () => {
  BEARER_TOKEN = getLocalStorage?.access_token;
  return BEARER_TOKEN;
};
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const humanize = (str: string): string => {
  var i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
};

export const chartColors: any = ["#3A5F89"];

export const CHART_AXIS_FALLBACK: {
  x: string;
  y: string;
  title: string;
} = {
  x: "X-Axis Name",
  y: "Y-Axis Name",
  title: "Chart Title",
};
